import { render } from "./dys.vue?vue&type=template&id=435f7748&scoped=true"
import script from "./dys.vue?vue&type=script&lang=js"
export * from "./dys.vue?vue&type=script&lang=js"

import "./dys.vue?vue&type=style&index=0&id=435f7748&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435f7748"]])

export default __exports__